// Fase da esteira de um vínculo na carteira (PO1-3166, revista na PO1-3281):
// lógica pura, testável, que traduz `esteira` ({ fase, status, temPasta,
// motivoDevolucao }) devolvido por GET /transportadoras/minhas.
//
// Por que existe uma coluna nova, ao lado da coluna Portal:
//
//   Portal   fala de IDENTIDADE — essa transportadora acessa o portal? A
//            resposta vem por RAIZ DE CNPJ, então vale para todos os
//            embarcadores dela ao mesmo tempo.
//   Esteira  fala do VÍNCULO — onde ESTE relacionamento está?
//
// Desde a PO1-3281 (épico PO1-3279) a fase sai direto do Status da habilitação:
//   AGUARDANDO_HOMOLOGACAO  transportadora nova, a Everlog ainda não liberou;
//   DEVOLVIDO               a Everlog devolveu; quem deu entrada corrige e reenvia;
//   EM_ONBOARDING           homologada; pastas, usuário SFTP e portal em andamento;
//   OPERACIONAL             onboarding completo (ou legado HOMOLOGADO);
//   REMOVIDO                o vínculo saiu da carteira.
// `EM_CONFIGURACAO` e `SEM_INTEGRACAO` ficam só por compatibilidade com uma API
// mais velha: o backend não os emite mais.

export const FASE = {
  AGUARDANDO_HOMOLOGACAO: "AGUARDANDO_HOMOLOGACAO",
  DEVOLVIDO: "DEVOLVIDO",
  EM_ONBOARDING: "EM_ONBOARDING",
  OPERACIONAL: "OPERACIONAL",
  REMOVIDO: "REMOVIDO",
  // Compat (API anterior à PO1-3281).
  EM_CONFIGURACAO: "EM_CONFIGURACAO",
  SEM_INTEGRACAO: "SEM_INTEGRACAO",
};

export const FASE_ROTULO = {
  AGUARDANDO_HOMOLOGACAO: "Aguardando homologação",
  DEVOLVIDO: "Devolvido",
  EM_ONBOARDING: "Em onboarding",
  OPERACIONAL: "Operacional",
  REMOVIDO: "Removido",
  EM_CONFIGURACAO: "Aguardando homologação",
  SEM_INTEGRACAO: "Sem integração",
};

export function esteiraEstado(esteira) {
  // Vínculo anterior à jornada, ou escopo inválido: não inventar uma fase.
  if (!esteira) {
    return { tipo: "sem-esteira", rotulo: "—", badge: "lock", ajuda: "", podeReenviar: false };
  }

  if (esteira.fase === FASE.OPERACIONAL) {
    return {
      tipo: "operacional",
      rotulo: FASE_ROTULO.OPERACIONAL,
      badge: "done",
      // Vale tanto para quem passou pela homologação quanto para o legado: a
      // decisão do Rodrigo em 20/09/2026 foi que a homologação é só para quem
      // está entrando, então todo vínculo anterior à jornada entrou homologado.
      ajuda: "Onboarding completo: pastas, usuário SFTP e portal prontos. Se recebe arquivo, veja a coluna SFTP.",
      podeReenviar: false,
    };
  }

  if (esteira.fase === FASE.EM_ONBOARDING) {
    return {
      tipo: "em-onboarding",
      rotulo: FASE_ROTULO.EM_ONBOARDING,
      badge: "auto",
      ajuda: "Homologada pela Everlog. Pastas, usuário SFTP e acesso ao portal estão sendo montados.",
      podeReenviar: false,
    };
  }

  if (esteira.fase === FASE.DEVOLVIDO) {
    return {
      tipo: "devolvido",
      rotulo: FASE_ROTULO.DEVOLVIDO,
      badge: "pend",
      ajuda: esteira.motivoDevolucao
        ? `A Everlog devolveu: ${esteira.motivoDevolucao}`
        : "A Everlog devolveu para ajuste.",
      // Quem deu a entrada corrige e manda de novo (POST /transportadoras/minhas/:id/reenviar-homologacao).
      podeReenviar: true,
    };
  }

  if (esteira.fase === FASE.REMOVIDO) {
    return {
      tipo: "removido",
      rotulo: FASE_ROTULO.REMOVIDO,
      badge: "lock",
      ajuda: "O vínculo saiu da carteira. Adicionar de novo retoma o onboarding.",
      podeReenviar: false,
    };
  }

  // Compat: API anterior à PO1-3281 ainda podia emitir SEM_INTEGRACAO para o
  // vínculo só de cotação. Não é mais emitido; fica para não quebrar a tela.
  if (esteira.fase === FASE.SEM_INTEGRACAO) {
    return {
      tipo: "sem-integracao",
      rotulo: FASE_ROTULO.SEM_INTEGRACAO,
      badge: "lock",
      ajuda: "Sem canal de CT-e. Vale para quem trabalha só com cotação.",
      podeReenviar: false,
    };
  }

  // AGUARDANDO_HOMOLOGACAO (ou o antigo EM_CONFIGURACAO, ou fase desconhecida).
  return {
    tipo: "aguardando-homologacao",
    rotulo: FASE_ROTULO.AGUARDANDO_HOMOLOGACAO,
    badge: "auto",
    ajuda: "Transportadora nova na Rede: a Everlog confere o cadastro e o contato de TI antes de liberar.",
    podeReenviar: false,
  };
}
